import http from "@/settings/apiSettings"
import ODataStore from "devextreme/data/odata/store"
import AppSettings from "@/settings/appSettings"

class PORTAL_CereriConcediiService {
  getODataStore() {
    return new ODataStore({
      url: AppSettings.API_Url_PortalHROdata + "PORTAL_CereriConcedii",
      key: "ID",
      version: 4,
      beforeSend: (e: any) => {
        e.headers = { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") };
      }
    });
  }

  add(data: any): Promise<any> {
    return http.clientPortalHROdata.post("/PORTAL_CereriConcedii", data, {
      headers: { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") }
    });
  }

  anuleaza(id: string): Promise<any> {
    return http.clientPortalHR.post(`/portal/cereri-concedii/${id}/anuleaza`, {}, {
      headers: { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") }
    });
  }

  getCalendarDepartament(structId: string, an: number, luna: number): Promise<any> {
    return http.clientPortalHR.get("/portal/calendar-departament", {
      params: { structId, an, luna },
      headers: { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") }
    });
  }

  getSarbatoriLegale(): Promise<any> {
    return http.clientPortalHR.get("/portal/sarbatori-legale", {
      headers: { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") }
    });
  }

  getFormInit(): Promise<any> {
    return http.clientPortalHR.get("/portal/cerere-concediu/form-init", {
      headers: { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") }
    });
  }

  getFlux(id: string): Promise<any> {
    return http.clientPortalHR.get(`/portal/cereri-concediu/${id}/flux`, {
      headers: { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") }
    });
  }

  getAprobatoriCurenti(): Promise<any> {
    return http.clientPortalHR.get(`/portal/cereri-concediu/aprobatori-curenti`, {
      headers: { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") }
    });
  }

  getZileCORamase(an: number): Promise<any> {
    return http.clientPortalHR.get("/portal/zile-co-ramase", {
      params: { an },
      headers: { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") }
    });
  }
}

export default new PORTAL_CereriConcediiService();
